/**
 * Hello World example component
 */
import {TweenMax, Power2, TimelineLite} from "gsap";
const _ = require('lodash')

var hidden, visibilityChange; 
if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support 
  hidden = "hidden";
  visibilityChange = "visibilitychange";
} else if (typeof document.msHidden !== "undefined") {
  hidden = "msHidden";
  visibilityChange = "msvisibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
  hidden = "webkitHidden";
  visibilityChange = "webkitvisibilitychange";
}


const svgShapes = [
  require('!!svg-inline-loader!../../img/content/wallpaper_shape-1.svg'),
  require('!!svg-inline-loader!../../img/content/wallpaper_shape-2.svg'),
  require('!!svg-inline-loader!../../img/content/wallpaper_shape-3.svg'),
  require('!!svg-inline-loader!../../img/content/wallpaper_shape-4.svg'),
  require('!!svg-inline-loader!../../img/content/wallpaper_shape-5.svg')
]





class shapeEmitter {
  // ..and an (optional) custom class constructor. If one is
  // not supplied, a default constructor is used instead:
  // constructor() { }
  constructor(options) {
    this.options = _.clone(options);
    this.isPaused = false;
    this.timer = false;
    this.x = this.options.x;
    this.y = this.options.startPos;
    this.speedMultiplier = .5;
    this.shapes = {};
    this.prevShape = 0;
    this.prevShapeRotation = 0;


    this.containerHeight = this.options.endPos - this.options.startPos;
    var nrOfShapes = Math.ceil((this.containerHeight) / this.options.size);

    //
    var widthMultiplier = this.options.containerWidth / 1600;
    if (widthMultiplier > 1) widthMultiplier = 1;
 this.speedMultiplier *= (widthMultiplier*1);


    for (let i=0; i<nrOfShapes; i++) {
      var progress = ((100/nrOfShapes) * i);
      if (i <= 0) {
        this.generateShape(false)
      } else {
        this.generateShape(true, progress/100);
      }
        

    //   var progress = ((100/nrOfShapes) * i);
    //   console.log(progress);
    //   this.generateShape(i, progress/100);
    }
   // console.log('nrOfShapes: '+nrOfShapes)
    // this.name = 'Polygon';
    // this.height = height;
    // this.width = width;
    
    
    /*
              container:container,
          startPos:startY,
          endPos:endY,
          size:tileWidth,
          x:i*(containerWidth/nrOfCols)
          */
   
   //this.generateShape(true)

    

  }

  setTimer(delay) {
    this.timer = setTimeout(_.bind(this.generateShape, this), delay * 1000)

  }

  getRandomShape() {
    let shapeId = _.sample([1,2,3,4])  
    if (shapeId === this.prevShape) return this.getRandomShape()
    return shapeId;
  }


  getShapeRotation() {
    let rotationId = _.sample([1,2,3,4])  
    if (rotationId === this.prevRotation) return this.getShapeRotation()
    return rotationId;
  }

  generateShape(doNotMultiply, progress) {
    if (this.isPaused) return;

    let self = this;
    let shapeId = this.getRandomShape()
    let rotationId = this.getShapeRotation()
    let shapeUuid = _.uniqueId();

    this.prevShape = shapeId
    this.prevShapeRotation =  rotationId 
    
    let shape =  document.createElement('div'); 
    shape.className = 'shape shape--'+shapeId+' shape-rotation-'+rotationId;
    shape.setAttribute('data-shape-id', shapeUuid);
    shape.innerHTML = svgShapes[shapeId];

    this.options.container.appendChild(shape)
    this.shapes[shapeUuid] = shape;


    // calculate the duration of the animation
    let difference = this.options.endPos - this.y;
    //this.duration = difference / (100*this.speedMultiplier) + this.random(-2,5)
    this.duration = difference / (100*this.speedMultiplier) + this.random(-1,2)

    let timePerPx = (this.duration) / difference

    if (!doNotMultiply) {
      TweenMax.delayedCall((this.options.size * timePerPx), _.bind(this.generateShape, this));
    }
      //console.log(doNotMultiply)
    //if (!doNotMultiply) TweenMax.delayedCall((this.options.size * timePerPx), _.bind(this.generateShape, this));

   //this.setTimer(this.options.size * timePerPx)

    TweenMax.set(shape,{x:this.x,y:this.y,opacity:0,rotation:this.random(-360,360)});

    // animate
    TweenMax.to(shape,this.random(0,2)+1,{opacity:1});
    let positionTween = TweenMax.to(shape,this.duration,{y:'+='+difference,ease:Linear.easeNone, onComplete:this.animationComplete, onCompleteParams:[self, shapeUuid]});
    let positionXTween = TweenMax.to(shape,this.random(2,10)+1,{x:'+='+(this.options.size/3), repeat:-1,yoyo:true,ease:Sine.easeInOut})

    let rotationTween = TweenMax.to(shape, this.random(18,28),{rotation:'+='+this.random(-360,360),ease:Sine.easeInOut})
    // console.log(this.duration);
    if (progress) {
      positionTween.time(this.duration*progress);
      //rotationTween.time(this.duration*progress);
    }
   

  
  }

  removeShape(id) {
    let shape = this.shapes[id]
    this.options.container.removeChild(shape);
    _.unset(this.shapes, id);

    // console.log(context.shapes[id]);
  }

  animationComplete(context, id) {
    context.removeShape(id)
    // console.log('remove');
    // console.log();
    // this.target.remove()
    //context.removeShape(id)
    //console.log()
    //console.log(el)
  }
  random(min, max){ return min + ( Math.random() * (max - min)) };

  pause() {
    this.isPaused = true;
    clearTimeout(this.timer)
  }

  destroy() {
    var self = this;
    return new Promise((resolve,reject) => {
      this.pause();
      TweenMax.killChildTweensOf( this.options.container );

      _.forEach(this.shapes, (shape, key) => {
        self.removeShape(key);
      })
      // remove the elements
      // _.forEach
      // while (this.shapes.length) { 
      //   let shape = this.shapes.pop(); 
      //   this.options.container.removeChild(shape);
      // }
      //   _.unset(object, 'a[0].b.c');

      resolve();
      // _.forEach(this.shapes, (shape) => {
      //   console.log(shape)
      // })
    })
 

  }

}





module.exports = function (app) {
  app.registerComponent('final-wallpaper', '.js-wallpaper', function (sb, el) {

    var container = el;
    var emitters = new Array();
    var isActive = true;
    
    var generateWallpaper = function() {
      isActive = true;
      var containerHeight = container.offsetHeight;
      var containerWidth = container.offsetWidth;

      var nrOfCols = 7
      var tileWidth = containerWidth / nrOfCols; // tile
      var tileHeight = tileWidth;
  
      let startY = -tileHeight;
      let endY = containerHeight + tileHeight;
      //let diffY = endY - startY


      for (let i=0; i < nrOfCols; i++) {
        let emitter = new shapeEmitter({
          container:container,
          containerWidth:containerWidth,
          containerHeight:containerHeight,
          startPos:startY,
          endPos:endY,
          size:tileWidth,
          x:i*(containerWidth/nrOfCols)
        })
      emitters.push(emitter)
      }
    }

    var destroyWallpaper = function() {
      while (emitters.length) { 
        let emitter = emitters.pop(); 
        emitter.destroy();
      }
    }



    var onResize = function(ev) {
      if (isActive) destroyWallpaper()
      isActive = false;
    }

    var debouncedGenerate = _.debounce(generateWallpaper, 1000);

    //var debouncedDestroy = _.debounce(destroyWallpaper, 250, { 'maxWait': 1000 });

    /* INIT ------------------------------------------- */
    return {
      init: function () {


        sb.subscribe('window/resize', onResize)
        sb.subscribe('window/resize', debouncedGenerate)

        generateWallpaper();
       // optie3(el)
        

//console.log('JavaScript Hello World initialized')
      },
      destroy: function () {
       // console.log('Hello World de-initialized')
      }
    }
  })
}



/*

*/


// WEBPACK FOOTER //
// ./assets/js/components/wallpaper.js